const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

/**
 * GET /password-recovery/view?t=TOKEN
 * { valid: true, token: "..." }
 * { valid: false, reason: "link-expired" }
 */
export async function validateToken(token) {
  console.log("API_BASE" + API_BASE)
  const res = await fetch(
    `${API_BASE}/esg-informativa/password-recovery/view?t=${encodeURIComponent(token)}`,
    { headers: { Accept: 'application/json' } }
  );
  if (!res.ok) throw new Error('network-error');
  return res.json();
}

/**
 * POST /password-recovery/request (application/x-www-form-urlencoded)
 * { status: "success" }
 * { status: "email-mismatch", error: "..." }
 * { status: "link-expired" }
 * { status: "generic-error" }
 */
export async function submitPasswordRequest(token, userEmail) {
  const res = await fetch(`${API_BASE}/esg-informativa/password-recovery/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ t: token, userEmail }).toString(),
  });
  if (!res.ok) throw new Error('network-error');
  return res.json();
}
